var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 2.00049H19.9999C20.2651 2.00049 20.5195 2.10585 20.707 2.29338C20.8947 2.48092 21 2.73528 21 3.00049V22.2765C21.0001 22.3599 20.9793 22.442 20.9395 22.5153C20.8998 22.5887 20.8422 22.6509 20.7723 22.6964C20.7022 22.7418 20.622 22.769 20.5389 22.7754C20.4557 22.782 20.3721 22.7675 20.296 22.7334L12 19.0305L3.704 22.7325C3.6279 22.7664 3.54452 22.781 3.46142 22.7745C3.37832 22.7681 3.29814 22.7409 3.22818 22.6956C3.15822 22.6503 3.1007 22.5882 3.06086 22.515C3.021 22.4418 3.00007 22.3598 3 22.2765V3.00049C3 2.73528 3.10536 2.48092 3.29289 2.29338C3.48044 2.10585 3.73479 2.00049 4.00001 2.00049ZM19.0001 19.9655V4.00048H4.99999V19.9655L12 16.8414L19.0001 19.9655ZM12 13.5005L9.061 15.0455L9.622 11.7735L7.245 9.45549L10.531 8.97748L12 6.00049L13.47 8.97748L16.755 9.45549L14.378 11.7735L14.938 15.0455L12 13.5005Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.f85b507e53fcbdc9b7c14a6e988209e3.svg";
export { ForwardRef as ReactComponent };